import { logError } from "shared/services/ErrorReporting";

export function capitalizeFirstLetter(str: string) {
  return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
}

export const openTargetLinkInNewTab = async (url: string): Promise<void> => {
  try {
    const response = await fetch(url);
    const html = await response.text();

    const parser = new DOMParser();
    const doc = parser.parseFromString(html, "text/html");

    const spanElement = doc.querySelector(
      'span[data-component-class="s-product-image"]',
    );
    if (spanElement) {
      const aTag = spanElement.firstElementChild as HTMLAnchorElement;
      if (aTag && aTag.href) {
        window.open(aTag.href, "_blank", "noopener,noreferrer");
      } else {
        logError("Target link not found within the span element.");
      }
    } else {
      logError(
        "Span element with data-component-class='s-product-image' not found.",
      );
    }
  } catch (error) {
    logError("Error fetching the URL:", { originalException: error });
  }
};

interface ButtonCopyArrayToClipboardProps {
  arrayToCopy: string[];
  delimiter?: string;
  onDone?: (content: string) => void;
  onError?: () => void;
}

export const copyToClipboard = async ({
  arrayToCopy,
  onDone,
  onError,
  delimiter = "; ",
}: ButtonCopyArrayToClipboardProps) => {
  const textToCopy = arrayToCopy.join(delimiter);
  try {
    await navigator.clipboard.writeText(textToCopy);
    onDone?.(textToCopy);
  } catch (err) {
    logError(err);
    onError?.();
  }
};

export function createArray(n: number) {
  return Array.from({ length: n }, (_, index) => index);
}

export const isNonNegativeInteger = (
  value: number | undefined,
): value is number =>
  value !== undefined && Number.isInteger(value) && value >= 0;

export const downloadFile = (url: string, name = "") => {
  const a = document.createElement("a");
  a.href = url;
  a.download = name;

  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
};
